<template>

<div v-if="isGranted([permissions.ACTIVITY_PROCESSING_TYPE_VIEW, permissions.ACTIVITY_PROCESSING_TYPE_VIEW_OWN], activity)"
     qid="processing-type-section"
     id="update_processing_type"
>
  <div class="card processing_type">
    <div class="card-header" :class="{'pr-0 pl-0': showOnTask}">
      <div class="float-right">
        <ValidationForm
            :object="activity"
            scope="validate_processing_type"
            type="processing_type"
            :checklist="validationOptions"
            @validationModalClose="handleValidationModalClose"
            v-if="!showOnTask && isGranted([permissions.ACTIVITY_PROCESSING_TYPE_VALIDATE, permissions.ACTIVITY_PROCESSING_TYPE_VALIDATE_OWN], activity)"
        ></ValidationForm>

        <span v-if="isGranted([permissions.ACTIVITY_PROCESSING_TYPE_EDIT, permissions.ACTIVITY_PROCESSING_TYPE_EDIT_OWN], activity)"
              class="float-right btn btn-success"
              qid="processing-type-edit-button"
              @click="showFormFunction"
        >
          <font-awesome-icon icon="pen"/> {{ $t('system.edit') }}
        </span>
      </div>
      <div class="float-left">
        <h5 class="mb-2" qid="processing-type-table-title" v-if="!showOnTask">
          {{ $t('activities.processing_type.title') }}
        </h5>

        <span v-if="!showOnTask">
          <span class="cursor-pointer task-label-open mr-2"
                v-if="getTask('update_processing_type')"
          >
            <UpdateSingleTaskModal
                :task="getTask('update_processing_type')"
                @reloadContent="reloadContent"
                :editIcon="true"
            ></UpdateSingleTaskModal>
          </span>
          <span v-if="getGuide('update_processing_type')">
            <GuideButton :guide="getGuide('update_processing_type')"></GuideButton>
          </span>
        </span>
      </div>

      <div class="validation-info" qid="view-processing-type-validation" v-if="validation && !showOnTask">
        <span v-if="validation && validation.validation === 1">
          <font-awesome-icon icon="check-circle" class="icon-success"/>
          {{ $t('system.approved') }}
        </span>
        <span v-if="validation && validation.validation === 0">
          <font-awesome-icon icon="times-circle" class="icon-danger"/>
          {{ $t('system.rejected') }}
        </span>
        <span v-if="validation" class="text-muted font-italic">
          {{ $t('system.by') }}
          <span v-if="validation.created_by" qid="view-processing-type-validation-by">
            {{ validation.created_by.name }}
          </span>
        </span>
        <span v-if="validation" class="text-muted font-italic">
          {{ $t('system.on') }}
          <span v-if="validation.created_at" qid="view-processing-type-validation-date">
            {{ validation.created_at | formatDate }}
          </span>
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="card-body">

          <div class="mw-500" v-if="showForm">
            <label for="">{{ $t('activities.processing_type.profiling') }}</label>
            <b-form-radio-group
              v-model="profiling"
              :options="radioOptions"
              qid="processing-type-form-radio-1"
              class="mt-2"
            ></b-form-radio-group>
            <br>
            <label for="">{{ $t('activities.processing_type.direct_marketing') }}</label>
            <b-form-radio-group
              v-model="direct_marketing"
              :options="radioOptions"
              qid="processing-type-form-radio-2"
              class="mt-1"
            ></b-form-radio-group>
            <br>
            <label for="">{{ $t('activities.processing_type.automated_decision') }}</label>
            <b-form-radio-group
              v-model="automated_decision"
              :options="radioOptions"
              qid="processing-type-form-radio-3"
              class="mt-1"
            ></b-form-radio-group>
            <br>
            <label for="">{{ $t('activities.processing_type.children') }}</label>
            <b-form-radio-group
              v-model="children"
              :options="radioOptions"
              qid="processing-type-form-radio-5"
              class="mt-1"
            ></b-form-radio-group>
            <br>
            <label for="">{{ $t('activities.processing_type.monitoring') }}</label>
            <b-form-radio-group
              v-model="monitoring"
              :options="radioOptions"
              qid="processing-type-form-radio-6"
              class="mt-1"
            ></b-form-radio-group>
            <br>
            <label for="">{{ $t('activities.processing_type.description') }}</label>
            <b-form-textarea
              qid="processing-type-form-description"
              v-model="automated_decision_description"
              rows="6"
              class="mt-2"
              :placeholder="$t('activities.processing_type.description_placeholder')"
            ></b-form-textarea>
            <div class="text-right">
              <b-button class="mt-3"
                        variant="secondary"
                        @click="cancelForm"
                        qid="create-processing-type-cancel-button"
              >
                {{ $t('activities.processing_type.cancel') }}
              </b-button>
              <b-button class="mt-3 ml-3"
                        variant="success"
                        @click="formSubmit"
                        qid="create-processing-type-submit-button"
              >
                {{ $t('activities.processing_type.submit') }}
              </b-button>
            </div>
          </div>

          <div v-if="!showForm">
            <div v-if="activity.gdpr">
              <label for="">{{ $t('activities.processing_type.profiling') }}</label>
              <p class="mt-2 section-container">
                <span v-if="activity.gdpr.profiling === 0">
                  <font-awesome-icon icon="times" class="mr-2 text-danger"/>
                  {{ $t('system.no') }}
                </span>
                <span v-if="activity.gdpr.profiling === 1">
                  <font-awesome-icon icon="check" class="mr-2 text-success"/>
                  {{ $t('system.yes') }}
                </span>
              </p>
              <br>
              <label for="">{{ $t('activities.processing_type.direct_marketing') }}</label>
              <p class="section-container">
                <span v-if="activity.gdpr.direct_marketing === 0">
                  <font-awesome-icon icon="times" class="mr-2 text-danger"/>
                  {{ $t('system.no') }}
                </span>
                <span v-if="activity.gdpr.direct_marketing === 1">
                  <font-awesome-icon icon="check" class="mr-2 text-success"/>
                  {{ $t('system.yes') }}
                </span>
              </p>
              <br>
              <label for="">{{ $t('activities.processing_type.automated_decision') }}</label>
              <p class="section-container">
                <span v-if="activity.gdpr.automated_decision === 0">
                  <font-awesome-icon icon="times" class="mr-2 text-danger"/>
                  {{ $t('system.no') }}
                </span>
                <span v-if="activity.gdpr.automated_decision === 1">
                  <font-awesome-icon icon="check" class="mr-2 text-success"/>
                  {{ $t('system.yes') }}
                </span>
              </p>
              <br>
              <label for="">{{ $t('activities.processing_type.children') }}</label>
              <p class="section-container">
                <span v-if="activity.gdpr.children === 0">
                  <font-awesome-icon icon="times" class="mr-2 text-danger"/>
                  {{ $t('system.no') }}
                </span>
                <span v-if="activity.gdpr.children === 1">
                  <font-awesome-icon icon="check" class="mr-2 text-success"/>
                  {{ $t('system.yes') }}
                </span>
              </p>
              <br>
              <label for="">{{ $t('activities.processing_type.monitoring') }}</label>
              <p class="section-container">
                <span v-if="activity.gdpr.monitoring === 0">
                  <font-awesome-icon icon="times" class="mr-2 text-danger"/>
                  {{ $t('system.no') }}
                </span>
                <span v-if="activity.gdpr.monitoring === 1">
                  <font-awesome-icon icon="check" class="mr-2 text-success"/>
                  {{ $t('system.yes') }}
                </span>
              </p>
              <br>
              <label for="">{{ $t('activities.processing_type.description') }}</label>
              <p class="text-formatted section-container" v-if="activity.gdpr.automated_decision_description">{{activity.gdpr.automated_decision_description }}</p>
              <p v-if="!activity.gdpr.automated_decision_description" class="text-muted section-container">
                {{ $t('system.missing_input') }}
              </p>
              <br>
            </div>
          </div>

        </div>

        <div class="text-center card-body" v-if="!showOnTask">
          <span class="cursor-pointer"
                @click="validationShow = !validationShow"
                qid="expand-processing-type-validations"
          >
            <span class="mr-2">
              {{ $t('system.view_validation_log') }}
            </span>
            <font-awesome-icon icon="chevron-down" v-if="!validationShow"/>
            <font-awesome-icon icon="chevron-up" v-if="validationShow"/>
          </span>
        </div>
        <div v-show="validationShow && !showOnTask" class="card-body">
          <ValidationList
              :object="activity"
              type="processing_type"
              :reloadList="updateValidationList"
              @validationListUpdated="setValidation"
          ></ValidationList>
        </div>
      </div>

    </div>
  </div>
</div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';


  export default {
    name: 'ProcessingType',
    data: function() {
      return {
        form: {},
        automated_decision_description: '',
        profiling: '',
        direct_marketing: '',
        automated_decision: '',
        children: '',
        monitoring: '',
        error: '',
        loadingItems: false,
        validationShow: false,
        updateValidationList: false,
        showForm: false,
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
        validation: undefined,
        activity: {},
        myGuides: [],
        myTasks: []
      }
    },
    props: {
      object: {
        type: Object
      },
      showOnTask: {},
      task: {}
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    components: {
      ValidationForm,
      ValidationList,
      UpdateSingleTaskModal,
      GuideButton
    },
    watch: {
      object: function (value) {
        this.activity = value
        this.setDefaultForm(value)
        this.loadTasks('update_processing_type');
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.activity.id && this.$store.state.updatedObject.who_am_i == this.activity.who_am_i) {
              this.activity = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_processing_type')
        }
      },
    },
    methods: {
      setValidation(object) {
        this.validation = object
      },
      reloadContent() {
        this.loadActivity()
        this.loadTasks('update_processing_type')
      },
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.activity.who_am_i,
              model_id: this.activity.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      openToolbar(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Activity' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Activity',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      formSubmit(evt) {
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        this.form.profiling = this.profiling;
        this.form.direct_marketing = this.direct_marketing;
        this.form.automated_decision = this.automated_decision
        this.form.children = this.children;
        this.form.monitoring = this.monitoring;
        this.form.automated_decision_description = this.automated_decision_description;

        piincHttp.put('activities/' + this.activity.slug, this.form).then(function(response) {
          self.activity = response.data
          self.$emit('updated');
          self.loadTasks('update_processing_type');
          self.showForm = false;
          self.$toastr('success', self.$t('activities.update.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.error = error.data.message;
          }
        })
      },
      handleValidationModalClose() {
        this.loadActivity();
        this.updateValidationList = true
      },
      cancelForm() {
        this.showForm = false
      },
      showFormFunction() {
        this.profiling = this.activity.gdpr.profiling
        this.direct_marketing = this.activity.gdpr.direct_marketing
        this.automated_decision = this.activity.gdpr.automated_decision
        this.children = this.activity.gdpr.children
        this.monitoring = this.activity.gdpr.monitoring
        this.automated_decision_description = this.activity.gdpr.automated_decision_description
        this.showForm = true
      },
      navigateToTask(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id }})
      },
      loadActivity() {
        let self = this;
        piincHttp.get('activities/' + this.activity.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.activity = response.data;
        }, function() {});
      },
      setDefaultForm(object) {
        this.profiling = this.activity.gdpr.profiling;
        this.direct_marketing = this.activity.gdpr.direct_marketing;
        this.automated_decision = this.activity.gdpr.automated_decision;
        this.children = this.activity.gdpr.children;
        this.monitoring = this.activity.gdpr.monitoring;
        this.automated_decision_description = this.activity.gdpr.automated_decision_description;
      }
    },
    created () {
      this.activity = this.object
      this.validationOptions = this.activity.processingTypeValidationOptions;

      if (this.activity && this.activity.slug) {
        this.loadTasks('update_processing_type');
      }

      this.setDefaultForm(this.activity)
      this.loadGuides('update_processing_type');

    }
  }
</script>
